import { createApp } from 'vue'
import DemoFlow from '../components/DemoFlow.vue'

export function mountDemo() {
  const el = document.getElementById('demo-app')
  if (!el) return

  const app = createApp(DemoFlow, {
    vocabUrl: el.dataset.vocabUrl,
    exerciseUrl: el.dataset.exerciseUrl,
    backUrl: el.dataset.backUrl,
    registerUrl: el.dataset.registerUrl,
    unitTitle: el.dataset.unitTitle,
  })
  app.mount(el)
}
